import { cva } from '@/styled-system/css';

export const propertyCardPhotoFallbackRecipe = cva({
  base: {
    'position': 'absolute',
    'insetInlineStart': '50%',
    'insetBlockStart': '50%',
    'transform': 'translate3d(-50%, -50%, 0)',

    '& > .c11n-property-card-fallback-fill': {
      fill: 'PropertyCard.PhotoFallback.icon',
    },
  },
  variants: {
    appearance: {
      large: {
        blockSize: 'PropertyCard.PhotoFallback.large.icon.height',
        inlineSize: 'PropertyCard.PhotoFallback.large.icon.width',
      },
      small: {
        blockSize: 'PropertyCard.PhotoFallback.small.icon.height',
        inlineSize: 'PropertyCard.PhotoFallback.small.icon.width',
      },
      horizontal: {
        blockSize: 'PropertyCard.PhotoFallback.horizontal.icon.height',
        inlineSize: 'PropertyCard.PhotoFallback.horizontal.icon.width',
      },
    },
  },
});
